(function () {
  if (window.__cjLuxuryQuickView) return;
  window.__cjLuxuryQuickView = true;

  // Ordered most-specific-first: matched by substring against the variant's
  // full option value (e.g. "10k Yellow Gold", "14k Rose Gold Two Tone"),
  // so "yellow gold" must be checked before the bare "gold" fallback.
  var METAL_COLORS = [
    ['rose gold', '#ecc5c0'],
    ['yellow gold', '#d4af37'],
    ['white gold', '#e9e9e6'],
    ['two tone', '#cbb98f'],
    ['platinum', '#e5e4e2'],
    ['silver', '#c8c8c8'],
    ['black', '#1a1a1a'],
    ['gold', '#d4af37'],
  ];

  function findMetalColor(value) {
    var lower = value.toLowerCase();
    for (var i = 0; i < METAL_COLORS.length; i++) {
      if (lower.indexOf(METAL_COLORS[i][0]) !== -1) return METAL_COLORS[i][1];
    }
    return null;
  }

  var modal, imageEl, dotsEl, titleLinkEl, descEl, priceEl, optionsEl, qtyInput, statusEl, addBtn, viewLinkEl;
  var currentProduct = null;
  var selectedOptions = [];

  function formatMoney(cents) {
    var format = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    var withDecimals = dollars + '.' + parts[1];
    return format.replace(/\{\{\s*\w+\s*\}\}/, withDecimals);
  }

  function init() {
    modal = document.getElementById('LuxuryQuickView');
    if (!modal) return;
    imageEl = modal.querySelector('[data-luxury-quick-view-image]');
    dotsEl = modal.querySelector('[data-luxury-quick-view-dots]');
    titleLinkEl = modal.querySelector('[data-luxury-quick-view-title-link]');
    descEl = modal.querySelector('[data-luxury-quick-view-description]');
    priceEl = modal.querySelector('[data-luxury-quick-view-price]');
    optionsEl = modal.querySelector('[data-luxury-quick-view-options]');
    qtyInput = modal.querySelector('[data-luxury-quick-view-qty-input]');
    statusEl = modal.querySelector('[data-luxury-quick-view-status]');
    addBtn = modal.querySelector('[data-luxury-quick-view-add]');
    viewLinkEl = modal.querySelector('[data-luxury-quick-view-view-link]');

    document.addEventListener('click', onDocClick);
    document.addEventListener('keyup', function (evt) {
      if (evt.key === 'Escape') closeModal();
    });

    modal.querySelector('[data-luxury-quick-view-qty-minus]').addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    });
    modal.querySelector('[data-luxury-quick-view-qty-plus]').addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
    });

    addBtn.addEventListener('click', addToCart);
  }

  function onDocClick(evt) {
    var opener = evt.target.closest('[data-luxury-quick-add]');
    if (opener) {
      if (opener.disabled) return;
      evt.preventDefault();
      evt.stopPropagation();
      openModal(opener.getAttribute('data-product-url'), opener);
      return;
    }
    if (evt.target.closest('[data-luxury-quick-view-close]')) {
      closeModal();
      return;
    }
    var dot = evt.target.closest('[data-luxury-quick-view-dot]');
    if (dot) {
      setImage(Number(dot.getAttribute('data-luxury-quick-view-dot')));
      return;
    }
    var pill = evt.target.closest('[data-luxury-quick-view-value]');
    if (pill) {
      var optIndex = Number(pill.getAttribute('data-option-index'));
      selectedOptions[optIndex] = pill.getAttribute('data-luxury-quick-view-value');
      renderOptions();
      updateVariant();
    }
  }

  function buildProductJsonUrl(url) {
    // Product URLs coming from a recommendations context carry Shopify's own
    // tracking query string (?pr_prod_strat=...&pr_rec_id=...&pr_seq=...),
    // so naively appending ".js" lands after those params instead of on the
    // path and silently returns the full product PAGE instead of its JSON
    // representation. Parse the URL properly and append ".js" to the path.
    var parsed = new URL(url, window.location.origin);
    parsed.pathname = parsed.pathname.replace(/\/$/, '') + '.js';
    return parsed.toString();
  }

  function openModal(url, opener) {
    if (!url) return;
    if (opener) opener.classList.add('is-loading');
    resetModal();
    modal.hidden = false;
    document.body.classList.add('overflow-hidden');
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
    });

    fetch(buildProductJsonUrl(url))
      .then(function (res) {
        return res.json();
      })
      .then(function (product) {
        renderProduct(product);
      })
      .catch(function (err) {
        console.error(err);
        closeModal();
      })
      .finally(function () {
        if (opener) opener.classList.remove('is-loading');
      });
  }

  function closeModal() {
    modal.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    setTimeout(function () {
      modal.hidden = true;
    }, 200);
  }

  function resetModal() {
    imageEl.src = '';
    dotsEl.innerHTML = '';
    delete dotsEl.dataset.images;
    titleLinkEl.textContent = '';
    descEl.textContent = '';
    priceEl.textContent = '';
    optionsEl.innerHTML = '';
    qtyInput.value = 1;
    statusEl.hidden = true;
    statusEl.textContent = '';
    addBtn.disabled = false;
    addBtn.textContent = 'Add to Cart';
    currentProduct = null;
    selectedOptions = [];
  }

  function renderProduct(product) {
    currentProduct = product;
    var firstVariant = product.variants[0];
    selectedOptions = firstVariant ? [firstVariant.option1, firstVariant.option2, firstVariant.option3] : [];

    titleLinkEl.textContent = product.title;
    titleLinkEl.setAttribute('href', product.url);
    viewLinkEl.setAttribute('href', product.url);

    var tmp = document.createElement('div');
    tmp.innerHTML = product.description || '';
    descEl.textContent = (tmp.textContent || '').trim();

    var images = product.images && product.images.length ? product.images : [product.featured_image];
    renderDots(images);
    setImage(0, images);

    renderOptions();
    updateVariant();
  }

  function renderDots(images) {
    dotsEl.innerHTML = '';
    dotsEl.dataset.images = JSON.stringify(images);
    if (images.length <= 1) return;
    images.forEach(function (src, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'luxury-quick-view__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('data-luxury-quick-view-dot', i);
      dot.setAttribute('aria-label', 'Image ' + (i + 1));
      dotsEl.appendChild(dot);
    });
  }

  function setImage(index, images) {
    images = images || (dotsEl.dataset.images ? JSON.parse(dotsEl.dataset.images) : []);
    if (!images || !images[index]) return;
    imageEl.src = images[index];
    dotsEl.querySelectorAll('.luxury-quick-view__dot').forEach(function (d, i) {
      d.classList.toggle('is-active', i === index);
    });
  }

  function renderOptions() {
    if (!currentProduct) return;
    optionsEl.innerHTML = '';
    currentProduct.options.forEach(function (optionRaw, optIndex) {
      // Shopify's /products/<handle>.js response returns `options` as an
      // array of plain strings on some API versions and as
      // { name, position, values } objects on others — support both.
      var optionName = (optionRaw && typeof optionRaw === 'object') ? optionRaw.name : optionRaw;

      var values = [];
      currentProduct.variants.forEach(function (v) {
        var val = v['option' + (optIndex + 1)];
        if (val != null && values.indexOf(val) === -1) values.push(val);
      });
      if (!values.length) return;

      var row = document.createElement('div');
      row.className = 'luxury-quick-view__option-row';

      var label = document.createElement('span');
      label.className = 'luxury-quick-view__option-label';
      label.textContent = optionName;
      row.appendChild(label);

      var pillWrap = document.createElement('div');
      pillWrap.className = 'luxury-quick-view__pills';

      var isColorOption = /colou?r|couleur/i.test(optionName);

      values.forEach(function (val) {
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.setAttribute('data-luxury-quick-view-value', val);
        pill.setAttribute('data-option-index', optIndex);
        pill.setAttribute('title', val);
        var isSelected = selectedOptions[optIndex] === val;

        if (isColorOption) {
          pill.className = 'luxury-quick-view__swatch' + (isSelected ? ' is-selected' : '');
          var hex = findMetalColor(val);
          if (hex) {
            pill.style.backgroundColor = hex;
          } else {
            pill.textContent = val.slice(0, 1);
          }
        } else {
          pill.className = 'luxury-quick-view__pill' + (isSelected ? ' is-selected' : '');
          pill.textContent = val;
        }
        pillWrap.appendChild(pill);
      });

      row.appendChild(pillWrap);
      optionsEl.appendChild(row);
    });
  }

  function findMatchingVariant() {
    if (!currentProduct) return null;
    for (var i = 0; i < currentProduct.variants.length; i++) {
      var v = currentProduct.variants[i];
      var opts = [v.option1, v.option2, v.option3];
      var matches = true;
      for (var j = 0; j < 3; j++) {
        if (opts[j] != null && opts[j] !== selectedOptions[j]) {
          matches = false;
          break;
        }
      }
      if (matches) return v;
    }
    return null;
  }

  function updateVariant() {
    var variant = findMatchingVariant();
    if (!variant) {
      priceEl.textContent = '—';
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
      return;
    }

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceEl.innerHTML = '<span class="luxury-quick-view__price--sale">' + formatMoney(variant.price) + '</span>';
    } else {
      priceEl.textContent = formatMoney(variant.price);
    }

    if (variant.featured_image && variant.featured_image.src && currentProduct.images) {
      var idx = currentProduct.images.indexOf(variant.featured_image.src);
      if (idx !== -1) setImage(idx);
    }

    addBtn.disabled = !variant.available;
    addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    addBtn.dataset.variantId = variant.id;
  }

  function addToCart() {
    var variantId = addBtn.dataset.variantId;
    if (!variantId) return;
    var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);

    addBtn.disabled = true;
    var originalText = addBtn.textContent;
    addBtn.textContent = 'Adding...';
    statusEl.hidden = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          throw new Error((result.data && result.data.description) || 'Cart error');
        }
        document.body.dispatchEvent(new CustomEvent('cart:updated', { detail: result.data, bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        closeModal();
      })
      .catch(function (err) {
        console.error(err);
        statusEl.hidden = false;
        statusEl.textContent = 'Something went wrong. Please try again.';
      })
      .finally(function () {
        addBtn.disabled = false;
        addBtn.textContent = originalText;
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
